<template>
  <section>
    <div class="grid grid-cols-12 gap-3 mt-5" v-if="loading">
      <!-- Return -->
        <div class="w-full sm:w-auto flex col-span-12">
          <router-link to="/admin/business/clients" class="button text-white bg-theme-1 shadow-md mr-2 mx-auto">
            Regresar
          </router-link>
        </div>
      <!-- END: Return -->

      <div class="col-span-12 md:col-span-12 box bg-white content">
        <!-- Title -->
        <div class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center" v-if="current.accounts.length">
          <h2 class="intro-y text-lg font-medium mr-auto mt-2">
            Cuentas Asignadas
          </h2>
        </div>
        <!-- END: Title -->

        <!-- List -->
        <div class="grid grid-cols-12 gap-3 mt-5">
          <div class="intro-y col-span-12 md:col-span-6" v-for="(account, index) in current.accounts" :key="index">
            <div class="box bg-theme-1 text-white">
              <div class="flex flex-col lg:flex-row items-center p-5 border-b border-gray-200">
                <div class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0">
                    <a href="#" class="font-medium">{{account.name}} - {{account.country.prefix}}</a>
                </div>
                <div class="flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0">
                    <a v-on:click="removeElement(account, 'clientaccount')" class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 zoom-in text-white">
                      <app-icon name="minus" classname="w-4 h-4 mr-2"></app-icon>
                    </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: List -->

        <!-- Title -->
        <div class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center" v-if="filteredAccounts.length">
          <h2 class="intro-y text-lg font-medium mr-auto mt-2">
              Cuentas Sin Asignar
          </h2>
        </div>
        <!-- END: Title -->

            <!-- List -->
        <div class="grid grid-cols-12 gap-3 mt-5">
          <div class="intro-y col-span-12 md:col-span-6" v-for="(account, index) in filteredAccounts" :key="index">
            <div class="box bg-gray-300">
              <div class="flex flex-col lg:flex-row items-center p-5 border-b border-gray-200">
                  <div class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0">
                      <a href="#" class="font-medium">{{account.name}} - {{account.country.prefix}}</a>
                  </div>
                  <div class="flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0">
                      <a v-on:click="addElement(account, 'clientaccount')" class="bg-gray-100 border flex h-8 items-center justify-center ml-2 pl-2 rounded-full w-8 zoom-in">
                        <app-icon name="plus" classname="w-4 h-4 mr-2"></app-icon>
                      </a>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: List -->
      </div>
    </div>

    <app-loading v-else></app-loading>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AssignAccountUser',
  data () {
    return {
      loading: false,
      boxedit: false,
      view: {
        entity: 'client',
        id: this.$route.params.id
      },
    }
  },
  computed: {
    ...mapGetters({
      current: 'getClient',
      accounts: 'getAccounts',
    }),
    filteredAccounts() {
      return this.accounts.filter((account) => {
        if (!this.current.accounts.some(item => item.id == account.id)) {
          return account
        }
      })
    },
  },
  async beforeMount () {

    try {
      await this.getList('account'),
      await this.getList('socialreason'),
      await this.lookCurrentElement(),

      this.loading = true
    } catch (error) {}
  },
  methods: {
    addElement(element, entity) {
      let form = {
        entity: entity,
        id: this.current.id,
        element_id: element.id,
      }

      this.store(form)
        .then(() => {
          this.lookCurrentElement()
        })
    },
    removeElement(element, entity) {
      let form = {
        entity: entity,
        id: this.current.id,
        element_id: element.id,
      }

      this.update(form)
        .then(() => {
          this.lookCurrentElement()
        })
    },
    async lookCurrentElement() {
      try {
        await this.show(this.view),

        this.loading = true
      } catch (error) {}
    },
    ...mapActions([
      'show',
      'getAll',
      'getList',
      'store',
      'update',
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading
  }
}
</script>



// WEBPACK FOOTER //
// RelationsClient.vue?8dece664